import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ErrPage } from "./ErrPage";

export default function ErrorsPage() {
  return (
    <Switch>
      <Redirect from="/error" exact={true} to="/error/err" />
      <Route path="/error/err" component={ErrPage} />
    </Switch>
  );
}
